import gql from 'graphql-tag';
export default gql`
  mutation UpdateCompanyById($input: UpdateCompanyByIdInput!) {
    updateCompanyById(input: $input) {
      clientMutationId
    }
  }
`;
